// Vendor styles
import './src/swiper.scss'
import './src/element-plus.scss'

// Component SCSS
import './src/aps-icons/aps-icons.scss'
import './src/aps-spacer/aps-spacer.scss'
import './src/aps-announcement/aps-announcement.scss'
import './src/aps-header/aps-header.scss'
import './src/aps-mega-menu/aps-mega-menu.scss'
import './src/aps-banner-home/aps-banner-home.scss'
import './src/aps-quick-links/aps-quick-links.scss'
import './src/aps-banner-inner/aps-banner-inner.scss'
import './src/aps-find-a-psych/aps-find-a-psych.scss'
import './src/aps-callout-tiles/aps-callout-tiles.scss'
import './src/aps-highlights/aps-highlights.scss'
import './src/aps-member-news/aps-member-news.scss'
import './src/aps-resources/aps-resources.scss'
import './src/aps-cta-large/aps-cta-large.scss'
import './src/aps-cta-medium/aps-cta-medium.scss'
import './src/aps-banner-inner/aps-banner-inner.scss'
import './src/aps-inner/aps-inner.scss'
import './src/aps-callout-tiles/aps-callout-tiles.scss'
import './src/aps-cpd-search/aps-cpd-search.scss'
import './src/aps-cpd-card/aps-cpd-card.scss'
import './src/aps-cpd-carousel/aps-cpd-carousel.scss'
import './src/aps-cpd-discover/aps-cpd-discover.scss'
import './src/aps-ad-block/aps-ad-block.scss'
import './src/aps-cpd-tags/aps-cpd-tags.scss'
import './src/aps-flyout/aps-flyout.scss'
import './src/aps-login/aps-login.scss'
import './src/aps-search/aps-search.scss'
import './src/aps-insights/aps-insights.scss'
import './src/aps-interest-groups/aps-interest-groups.scss'

// Component JS
import './src/aps-announcement/aps-announcement.js'
import './src/aps-header/aps-header.js'
import './src/aps-mega-menu/aps-mega-menu.js'
import './src/aps-inner/aps-inner.js'
import './src/aps-resources/aps-resources.js'
import './src/aps-callout-tiles/aps-callout-tiles.js'
import './src/aps-cpd-carousel/aps-cpd-carousel.js'
import './src/aps-cpd-discover/aps-cpd-discover.js'
import './src/aps-cpd-search/aps-cpd-search.js'
import './src/aps-find-a-psych/aps-find-a-psych.js'
import './src/aps-flyout/aps-flyout.js'
import './src/aps-login/aps-login.js'
import './src/aps-search/aps-search.js'

// Vue app for CPD search results
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import ApsCpdResults from './src/aps-cpd-results/aps-cpd-results.vue'

const $cpdResults = document.querySelector('#aps-cpd-results')
if ($cpdResults) createApp(ApsCpdResults).use(ElementPlus).mount($cpdResults)
